const USER_SESSION_STORAGE_KEY = '@auth/user';
const ENCODE_KEY = 'base64';
const DECODE_KEY = 'ascii';
const DECODE_KEY_UTF_8 = 'UTF-8';

export default class UserUtils {
  createUserSessionStorage(userSessionStorage) {
    if (userSessionStorage) {
      // eslint-disable-next-line max-len
      sessionStorage.setItem(USER_SESSION_STORAGE_KEY, Buffer.from(JSON.stringify(userSessionStorage)).toString(ENCODE_KEY));
    }
  }

  getUserSessionStorage() {
    if (!sessionStorage.getItem(USER_SESSION_STORAGE_KEY)) {
      return null;
    }
    // eslint-disable-next-line max-len
    try {
      return JSON.parse(Buffer.from(sessionStorage.getItem(USER_SESSION_STORAGE_KEY), ENCODE_KEY).toString(DECODE_KEY));
    } catch(e) {
      return JSON.parse(Buffer.from(sessionStorage.getItem(USER_SESSION_STORAGE_KEY), ENCODE_KEY).toString(DECODE_KEY_UTF_8));
    }    
  }

  hasAuthorityToAccess(meta) {
    const userSessionStorage = this.getUserSessionStorage();
    // eslint-disable-next-line max-len
    if (meta && meta.authority) {
      // eslint-disable-next-line max-len
      if (!userSessionStorage || !userSessionStorage.authorities || !this.hasAuthority(userSessionStorage.authorities, meta.authority)) {
        return false;
      }
    }
    return true;
  }

  hasAuthority(authorities, authority) {
    return authorities.some((element) => element.authority === authority);
  }
}
